import { render } from "./LoginView.vue?vue&type=template&id=2131984f&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=2131984f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131984f"]])

export default __exports__